import { roomDetailsActionTypes } from '@/admin/pages/studyGoRoomDetails/Constants';

import type { RoomDetailsActions } from '@/admin/pages/studyGoRoomDetails/Actions';
import type { RoomDetailsState } from '@/admin/pages/studyGoRoomDetails/types';

const initialState: RoomDetailsState = {
	room: null,
	loading: false,
	error: null,
};

export default function roomDetailsReducer(
	state = initialState,
	action: RoomDetailsActions,
): RoomDetailsState {
	switch (action.type) {
		case roomDetailsActionTypes.GET_ROOM_DETAILS_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case roomDetailsActionTypes.GET_ROOM_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				room: action.payload.room,
				error: null,
			};
		case roomDetailsActionTypes.GET_ROOM_DETAILS_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
			};
		case roomDetailsActionTypes.CLEAN_ROOM_DETAILS_STATE:
			return initialState;
		default:
			return state;
	}
}
